import "./App.scss";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/common/Navbar";
import Sidebar from "./components/common/Sidebar";
import Footer from "./components/common/Footer";
import AppRoutes from "./routes/Routes";
import axiosInstance from "./api/axios";

function App() {
  const location = useLocation();
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const token = localStorage.getItem("rutex_auth_token");
        if (!token) return;
        
        const res = await axiosInstance.get("/core/settings");
        if (res.data && res.data.data) {
          const { ui } = res.data.data;
          if (ui) {
            const primary = ui.primary_color || "#183eeb";
            const secondary = ui.secondary_color || "#00024f";
            
            const css = `
              :root {
                --brand-primary: ${primary};
                --brand-secondary: ${secondary};
              }
              .sidebar {
                background: ${secondary} !important;
              }
              .btn-primary, .btn-primary:focus, .btn-primary:active {
                background-color: ${primary} !important;
                border-color: ${primary} !important;
              }
              .btn-primary:hover {
                background-color: ${primary}d0 !important;
                border-color: ${primary}d0 !important;
              }
              .text-primary {
                color: ${primary} !important;
              }
              .bg-primary {
                background-color: ${primary} !important;
              }
              .badge-primary {
                background-color: ${primary} !important;
              }
              .sidebar .nav .nav-item .nav-link i.menu-icon {
                color: #9fb2ff !important;
              }
            `;
            
            let styleEl = document.getElementById("dynamic-theme-styles");
            if (!styleEl) {
              styleEl = document.createElement("style");
              styleEl.id = "dynamic-theme-styles";
              document.head.appendChild(styleEl);
            }
            styleEl.innerHTML = css;
          }
        }
      } catch (err) {
        console.error("Error loading dynamic theme colors:", err);
      }
    };
    // fetchTheme();
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.add("sidebar-fixed");
    return () => {
      document.body.classList.remove("sidebar-fixed");
    };
  });

  useEffect(() => {
    const fullPageLayoutRoutes = [
      "/user-pages/login",
      "/user-pages/login-2",
      "/user-pages/register",
      "/user-pages/register-2",
      "/user-pages/lock-screen",
      "/user-pages/force-password-change",
      "/actualizar-clave-inicial",
      "/error-pages/404",
      "/error-pages/500",
      "/general-pages/landing",
    ];
    setIsFullPageLayout(fullPageLayoutRoutes.includes(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    const pageBodyWrapper = document.querySelector(".page-body-wrapper");
    if (isFullPageLayout) {
      pageBodyWrapper.classList.add("full-page-wrapper");
      pageBodyWrapper.style.setProperty('width', '100%', 'important');
      document.body.classList.remove("sidebar-fixed");
    } else {
      pageBodyWrapper.classList.remove("full-page-wrapper");
      pageBodyWrapper.style.removeProperty('width');
      document.body.classList.add("sidebar-fixed");
    }
  }, [isFullPageLayout]);

  useEffect(() => {
    const body = document.querySelector("body");
    if (location.pathname === "/rtl") {
      body.classList.add("rtl");
      body.classList.remove("sidebar-fixed");
    } else {
      body.classList.remove("rtl");
    }
  }, [location.pathname]);

  return (
    <div className="container-scroller">
        {!isFullPageLayout && <Sidebar />}
      <div className="container-fluid page-body-wrapper">
      {!isFullPageLayout && <Navbar />}
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes />
          </div>
          {!isFullPageLayout && <Footer />}
        </div>
      </div>
    </div>
  );
}

export default App;
